import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    api
      .post("/auth/google/session", { session_id })
      .then(({ data }) => {
        setUser(data.user);
        const dest = data.user.role === "club_admin" ? "/admin" : "/dashboard";
        navigate(dest, { replace: true });
      })
      .catch((err) => {
        setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-center">
        <div className="overline">Authenticating</div>
        <div className="font-serif text-3xl text-[#1A422D] mt-2">One moment, please…</div>
        {error && <div className="mt-4 text-sm text-[#8a1a1a]">{error}</div>}
      </div>
    </div>
  );
}
